import { useNavigate, Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { Container, Row, Col, Form } from 'react-bootstrap';
import 'boxicons/css/boxicons.min.css';
import TopBar from "./TopBar";
import React, { useRef, useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";



const DefaultArthiksakha = () => {
    const navigate = useNavigate();
    const { auth } = useAuth();
    const [selectedCategories, setSelectedCategories] = useState("");
    const [categoriesList, setCategoriesList] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [errorMessage, setErrorMessage] = useState("");
    const UPDATE_DEFAULT_ARTHIK_SAKHA = "set-user-default-arthik-sakha";
    const [errMsg, setErrMsg] = useState("");
    const [sucssMsg, setSucssMsg] = useState("");
    const errRef = useRef();
    const [ArthiksakhaList, setArthiksakhaList] = useState([]);
    const [selectedLevelId, setSelectedLevelId] = useState(auth.level_id);
    const [UserAccessLevels, setUserAccessLevels] = useState([]);


    const showMessage = (type, message) => {
        if (type === 'error') {
            setErrMsg(message);
            setSucssMsg(""); // ensure success message is cleared
        } else if (type === 'success') {
            setSucssMsg(message);
            setErrMsg(""); // ensure error message is cleared
        }

        // Auto-hide after 10 seconds
        setTimeout(() => {
            setErrMsg("");
            setSucssMsg("");
        }, 10000); // 10000ms = 10 seconds
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedLevelId) {
            setErrorMessage("Please select a Arthiksakha.");
            return;
        } else {
            setErrorMessage(""); // clear any previous error

            try {
                var data = JSON.stringify({
                    arthik_sakha_id: selectedLevelId,
                    setDefault: true
                });

                const response = await axiosPrivate.post(UPDATE_DEFAULT_ARTHIK_SAKHA, data, {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                });

                showMessage('success', response?.data?.message);
                // ✅ Redirect after successful update
                if (response?.status === 200) {
                    // Example URL — change this to your desired path
                    window.location.href = "/ArthiksakhaDashboard/";
                }

            } catch (err) {
                if (!err?.response) {
                    setErrMsg("No Server Response");
                } else if (err.response?.data?.message) {
                    const errorMsg = typeof err.response.data.message === 'string'
                        ? err.response.data.message
                        : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
                    setErrMsg(errorMsg);
                } else {
                    setErrMsg("Registration Failed");
                }
                errRef.current.focus();
            }
        }


    };



    const fetchArthiksakhaList = async () => {
        try {
            const response = await axiosPrivate.get('get-user-access-levels');

            if (response.data.length > 0) {
                setArthiksakhaList(response.data);

                // Check if current Arthiksakha exists in the response
                const exists = response.data.some(item => item.level_id === auth.level_id);

                if (exists) {
                    setSelectedLevelId(auth.level_id);
                } else {
                    setSelectedLevelId(""); // Show blank dropdown
                }
            }
        } catch (error) {
            console.error("Error fetching Arthiksakha list:", error);
        }
    };




    useEffect(() => {
        fetchArthiksakhaList();
    }, []);


    return (

        <Container>

            <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
            <section className="adminsec">

                <div className="center-image">

                    {/* <img src="/images/newlogo.png" width="20%" className='' /> */}
                </div>
                {/* <h1 className="adminhead">Dashbord</h1> */}
                <br />
                <center><h2 className="dashwel">Change Default Arthiksakha of <span className="colorChange">{auth?.name}</span> !</h2> </center>



                <div className="spclrow">
                    <center><p className="dashwel">Current Default Arthiksakha: {auth?.level_name}</p></center>
                    <form onSubmit={handleSubmit}>

                        <Form.Label>Select Arthiksakha</Form.Label>
                        {errorMessage && (
                            <p style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</p>
                        )}
                        <Form.Control
                            as="select"
                            value={selectedLevelId}
                            onChange={(e) => setSelectedLevelId(Number(e.target.value))}
                            className="vibhaglist"
                        >
                            {/* Optional empty default */}
                            <option value="">-- Select Arthiksakha --</option>

                            {ArthiksakhaList.map((Arthiksakha) => (
                                <option key={Arthiksakha.level_id} value={Arthiksakha.level_id}>
                                    {Arthiksakha.level_name}
                                </option>
                            ))}
                        </Form.Control>




                        <button type="submit" className="btn newpagebtn">Submit</button>
                    </form>
                </div>
            </section>
            <TopBar />
        </Container>
    )
}

export default DefaultArthiksakha
